import { faFill } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, message, Tooltip, Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../redux';
import ColorPicker from '../ColorPicker';
import SettingForm from '../SettingForm';

import { clamp } from 'lodash';
import {
  eventBus,
  getCurrentState,
  MAXIMUM_PAGESIZE,
  MINIMUM_CUSTOM_PAGESIZE,
  updateBackgroundImageFromPageSetting,
  PAGE_OPTION,
} from '../../utils';
import { KEYS_CODE } from '../../utils/keysCode';
import './styles.scss';

const { Panel } = Collapse;
const { Option } = Select;
const coordinates = [
  { label: 'w', name: 'width', key: 'w', imageBackgroundKey: 'width' },
  { label: 'h', name: 'height', key: 'h', imageBackgroundKey: 'height' },
];

const PageSettings = () => {
  const pageSettings = useSelector((appState) => appState.pages.settings);
  const { isLocked = false } = pageSettings;
  const dispatch = useDispatch();
  if (window.canvas) {
    window.canvas.renderAll();
  }
  const onChangeColor = (color) => {
    if (window.canvas?.backgroundImage?.type === 'rect') {
      eventBus.emit('save-canvas-state', getCurrentState());
      dispatch(actions.editPageSettings({ ...pageSettings, color: color }));
      window.canvas.backgroundImage.set({
        fill: color,
        settings: {
          ...pageSettings,
          color,
        },
      });
      window.canvas.renderAll();
    }
  };
  const handleChange = (value, key) => {
    eventBus.emit('save-canvas-state', getCurrentState());
    dispatch(actions.editPageSettings({ [key]: value }));
    updateBackgroundImageFromPageSetting({
      ...pageSettings,
      [key]: value,
    });
    window.canvas.renderAll();
  };

  const checkPageSizeChange = (e, key) => {
    const size = parseInt(e.target.value);
    if (size === pageSettings[key]) return;
    if (size < MINIMUM_CUSTOM_PAGESIZE || size > MAXIMUM_PAGESIZE) {
      message.destroy();
      message.warning(
        `The edge size of the page must be in range (${MINIMUM_CUSTOM_PAGESIZE}, ${MAXIMUM_PAGESIZE})`,
        5,
      );
    } else handleChange(clamp(parseInt(e.target.value), MINIMUM_CUSTOM_PAGESIZE, MAXIMUM_PAGESIZE), key);
  };
  const handleChangePageType = (e) => {
    dispatch(actions.editPageSettings(JSON.parse(e)));
    updateBackgroundImageFromPageSetting({ ...JSON.parse(e) });
  };

  const settings = [
    {
      key: 'size',
      header: 'Size',
      data: (
        <div className="row">
          {coordinates.map((item, index) => (
            <SettingForm
              step={5}
              key={index}
              className="custom"
              type="number"
              useInputNumber
              title={item.name}
              min={MINIMUM_CUSTOM_PAGESIZE}
              max={MAXIMUM_PAGESIZE}
              textTitle={item.label}
              onStep={(value) => handleChange(value, item.key)}
              onKeyDown={(e) => {
                if (e.keyCode === KEYS_CODE.ENTER) checkPageSizeChange(e, item.key);
                e.stopPropagation();
              }}
              onBlur={(e) => checkPageSizeChange(e, item.key)}
              value={Math.round(pageSettings[item.key]) || 0}
              disabled={!isLocked}
            />
          ))}
        </div>
      ),
    },
    {
      key: 'background',
      header: 'Background',
      data: (
        <div className="setting-item">
          <span className="icon">
            <FontAwesomeIcon icon={faFill} style={{ fontSize: '16px' }} />
          </span>
          <Tooltip title="Background Color">
            <ColorPicker onChange={onChangeColor} type="stroke" color={pageSettings.color} place="settings" />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div className="settings-inside">
      <div className="mo__page-settings">
        <div className="page-settings__wrapper">
          <span className="page-settings">Page Settings</span>
        </div>
        <div className="details">
          <Collapse bordered={false} collapsible="header" className="collapse" activeKey={settings.map((s) => s.key)}>
            <Panel
              header={
                <div className="page-type-wrapper">
                  <div className="page-type-container">
                    <div>TYPE:</div>
                    <div className="title">{pageSettings.label}</div>
                  </div>
                  <Select
                    showSearch
                    defaultValue={{
                      label: pageSettings.label,
                      isLocked: pageSettings.isLocked,
                      w: pageSettings.w,
                      h: pageSettings.h,
                    }}
                    filterOption={(input, option) => {
                      const { label } = JSON.parse(option.value);
                      return label.toLowerCase().includes(input.toLowerCase());
                    }}
                    listHeight={450}
                    className="page-type-select"
                    onChange={handleChangePageType}
                  >
                    {PAGE_OPTION.map((option, index) => {
                      const value = JSON.stringify(option.value);
                      const { label, w, h } = option.value;
                      return (
                        <Option value={value} key={value}>
                          <div className="option-row">
                            <div className="label" style={{ width: index === 0 && '100%' }}>
                              {label}
                            </div>
                            <div className="size">{index === 0 ? '' : `${w}x${h}`}</div>
                          </div>
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              }
              className="item"
              showArrow={false}
            ></Panel>
            {settings.map((item) => (
              <Panel key={item.key} header={item.header.toUpperCase()} className="item" showArrow={false}>
                <div className={`content ${item.key}`}>{item.data}</div>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default PageSettings;
